import {Injectable} from '@angular/core';
import {forkJoin, Observable} from 'rxjs';
import {Observables} from './observables';
import {UnitOfWorkService} from './unit-of-work.service';
import {EntityManagerEventService, EventType} from './entity-manager-event.service';
import {EntityManagerRepositoryFactoryService} from './repository/entity-manager-repository-factory.service';
import {EntityRepository} from './repository/entity-repository';
import {EntityManagerStateService, State} from './entity-manager-state.service';

@Injectable({
    providedIn: 'root'
})
export class EntityManagerService {

  private observables: Observables = new Observables();

  public constructor(
    private unitOfWorkService: UnitOfWorkService,
    private event: EntityManagerEventService,
    private repositoryFactory: EntityManagerRepositoryFactoryService,
    private state: EntityManagerStateService
  ) {
  }

  public persist(entity: any): EntityManagerService {
    this.event.run(entity, EventType.PrePersist);

    this.unitOfWorkService.persist(entity);

    return this;
  }

  public remove(entity: any): EntityManagerService {
    this.event.run(entity, EventType.PreRemove);

    this.unitOfWorkService.remove(entity);

    return this;
  }

  public flush(entity: any = null): Observable<any> {
    this.event.runPreFlush(entity);

    return this.unitOfWorkService.commit(entity);
  }

  public getRepository(entity: any): EntityRepository|any {
    return this.repositoryFactory.createRepository(entity);
  }

  public add(observable: Observable<any>): EntityManagerService {
    this.observables.add(observable);

    return this;
  }

  public clear(): void {
    this.unitOfWorkService.clear();
    this.observables.clear();
  }

  public collect(): Observable<Observables> {

    return Observable.create(observer => {

      forkJoin(this.observables.getAll())
        .subscribe(
          (observables: Observable<any>[]) => {

            this.observables.clear();

            observer.next(new Observables(observables));
            observer.complete();
          });

      if (this.observables.count() === 0) {
        observer.next([]);
        observer.complete();
      }
    });
  }
}
